module.exports = __webpack_public_path__ + "static/media/neva_iphone.340dd0b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/neva/neva_iphone.png
// module id = 340
// module chunks = 0